// extracted by mini-css-extract-plugin
export default {"main":"empowered_main__Fs30i","text":"empowered_text__Pm8V3","applyButton":"empowered_applyButton__EqAbP"};